import { getCookieDomain, getPlanHomeUrl } from './getPlanHomeUrl';
import Cookies from 'js-cookie';
import { BroadcastChannel } from 'broadcast-channel';

export const postMessageToPlanHome = massage => {
  const expirationDate = new Date(new Date().getTime() + 5 * 1000);

  Cookies.set('redirect_to', massage, {
    domain: getCookieDomain(),
    expires: expirationDate,
  });

  const channel = new BroadcastChannel('plan_application_channel', {
    type: 'localstorage',
  });
  channel.postMessage(massage);

  if (window.opener) {
    window.opener.postMessage(massage, getPlanHomeUrl());
  }
};
